import { useEffect, useState } from "react";
import toast from "react-hot-toast";

export default function DeactivateUserModal({ open, onClose, loading, user, onConfirm }) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!open) return;
    setReason("");
  }, [open]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) return toast.error("Reason is required");
    if (typeof onConfirm !== "function") return toast.error("onConfirm is missing");
    await onConfirm(reason.trim());
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/30 grid place-items-center p-4">
      <div className="w-full max-w-lg bg-white rounded-2xl border p-5 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between">
          <div className="text-lg font-bold">Deactivate User</div>
          <button onClick={onClose} className="text-sm px-3 py-1 rounded-lg hover:bg-gray-100">
            Close
          </button>
        </div>

        <form onSubmit={submit} className="mt-4 space-y-3">
          <div className="text-sm text-gray-700">
            Deactivating:{" "}
            <b>{[user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.email || user?.mobile_no || "-"}</b>
          </div>

          <div>
            <label className="text-sm font-semibold">Reason</label>
            <textarea
              className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
              rows={3}
              placeholder="Enter reason..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="rounded-xl border px-4 py-2 text-sm font-semibold hover:bg-gray-50">
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="rounded-xl bg-black px-4 py-2 text-white text-sm font-semibold disabled:opacity-60"
            >
              {loading ? "Deactivating..." : "Deactivate"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
